import { IComboBoxOption } from "@fluentui/react";
import { APP_SETTINGS } from "../config/config";
import { ILabInventory } from "../pages/lab-inventory/type";


export const getLeaseStatus = (leases: IEcaasLease[] | [] | null) => {
  let leaseStatus = "Available";
  if (leases && leases?.length > 0) {
    const currentLease = leases[0];
    const itemStatus = currentLease.itemStatus;
    if (itemStatus === "Completed" || itemStatus === "")
      leaseStatus = "Available";
    else if (itemStatus === "CheckedOut") leaseStatus = "In Use";
    else if (itemStatus === "ValidationPending") leaseStatus = "Pending";
  }
  return leaseStatus;
};

export const getToolName = (toolId: number) => {
  const selectedOption: IComboBoxOption[] | undefined =
    APP_SETTINGS.LAB_INVENTORY_ALL_TOOLS.filter((tool) => tool.key === toolId);
  if (selectedOption && selectedOption.length > 0) {
    return selectedOption[0].text;
  } else {
    return "";
  }
};

export const isValidBase64 = (str: string) => {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
};


export const formatInventoryDetailsData = (inventoryDetails: ILabInventory, key: any, value: any) => {
  if (key.includes('purchasingProject')) {
    return inventoryDetails.purchasingProjectNavigationName;
  }
  if (key.includes('inventoryType')) {
    return inventoryDetails.inventoryTypeNavigationName;
  }
  if (key.includes('inventoryCategory')) {
    return inventoryDetails.inventoryCategoryNavigationName;
  }
  if (key.includes("itemStatus")) {
    return inventoryDetails.ecaasStatusNavigationName;
  }
  if (key.includes("isTented") && Boolean(value) === true) {
    return inventoryDetails?.tentedSecurityGroup;
  }
  if (key.slice(0, 2) === "is") {
    //e.g isTented, isConsumable, etc
    return value?.toString() ?? "False";
  }
  if (
    key.includes("thirdPartyRentalStartDate") &&
    inventoryDetails.ecaasleases?.[0]?.ecaasInfo?.thirdPartyRentalStartDate
  ) {
    return formatUSDate(inventoryDetails.ecaasleases[0].ecaasInfo?.thirdPartyRentalStartDate) ?? "N/A";
  }
  if (
    key.includes("thirdPartyRentalDueDate") &&
    inventoryDetails.ecaasleases?.[0]?.ecaasInfo?.thirdPartyRentalDueDate
  ) {
    return formatUSDate(inventoryDetails.ecaasleases[0].ecaasInfo?.thirdPartyRentalDueDate);
  }
  if (
    key.includes("leaseStartDate") &&
    inventoryDetails.ecaasleases?.[0]?.leaseStartDate
  ) {
    return formatUSDate(inventoryDetails.ecaasleases[0].leaseStartDate) ?? "N/A";
  }
  if (
    key.includes("leaseEndDate") &&
    inventoryDetails.ecaasleases?.[0]?.leaseEndDate
  ) {
    return formatUSDate(inventoryDetails.ecaasleases[0].leaseEndDate) ?? "N/A";
  }
  if (key.includes("Date") && value) {
    return formatUSDate(value);
  }
  if (key.includes("leaseStatus")) {
    if (inventoryDetails.ecaasleases?.[0])
      return getLeaseStatus([inventoryDetails.ecaasleases[0]]);
    else
      return getLeaseStatus([]);
  }
  if (key.includes("quantity")) {
    return (
      Number(inventoryDetails["availableQuantity"]) +
      Number(inventoryDetails["underRepairQuantity"]) +
      Number(inventoryDetails["inUseQuantity"]) +
      Number(inventoryDetails["retiredQuantity"])
    );
  }
  if (value) {
    return value;
  } else {
    return "N/A";
  }
};

export const formatUSDate = (date?: string | Date) => {
  if (!date) return "";

  const d = new Date(date);
  if (isNaN(d.getTime())) return "";

  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();

  return `${month}/${day}/${year}`;
};

export const formatDate = (date: Date): string => {
  const month = date.getMonth() + 1; // + 1 because 0 indicates the first Month of the Year.
  const day = date.getDate();
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
};
export function formatDateTime(date?: Date | null): string {
  if (!date) return 'Not Available';

  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  }).replace(',', '');
}
export const formatECAASLeaseData = (
  leaseDetails: IEcaasLease,
  key: any,
  value: any
) => {
  if (key.includes("leaseStartDate") && leaseDetails.leaseStartDate) {
    return formatUSDate(leaseDetails.leaseStartDate);
  }
  if (key.includes("leaseEndDate") && leaseDetails.leaseEndDate) {
    return formatUSDate(leaseDetails.leaseEndDate);
  }
  if (key?.includes("user")) {
    return value?.alias ?? "N/A";
  }
  if (key?.includes("project")) {
    return value?.name ?? "N/A";
  }
};



export const validateIsRoleLabEngineer = (userDetails: any) => {
  return ((userDetails?.permissionRoles?.length === 1 &&
    userDetails?.permissionRoles?.includes("LabEngRW")) ||
    (typeof userDetails?.permissionRoles === "string" &&
      userDetails?.permissionRoles?.includes("LabEngRW")) ||
    userDetails?.permissionRoles?.length === 0 ||
    userDetails?.permissionRoles === null ||
    userDetails?.permissionRoles === "");
}

export const validatePermissionLevel = (
  userDetails: { permissionRoles?: string[] },
  authorizedPermissions: string[]
): boolean => {
  const userPermissions = userDetails.permissionRoles ?? [];
  return userPermissions.some(permission =>
    authorizedPermissions.includes(permission)
  );
};

export const isReadOnlyUser = (userDetails: {
  permissionRoles?: string[];
}): boolean => {
  const readOnlyRoles = ["LabEngRO"];
  const roles = userDetails.permissionRoles ?? [];
  return roles.length === 1 && readOnlyRoles.includes(roles[0]);
};

export const checkIfSgnameExists = (
  userSecurityGroup: Array<IUserGroups> | null,
  sgname: any
) => {
  if (userSecurityGroup) {
    return userSecurityGroup.some((item) => item.sgname === sgname);
  } else {
    return false;
  }
};

export const IsIMSTaiwan = (labInventoryItem: ILabInventory) => {
  const IMSData: IComboBoxOption[] =
    APP_SETTINGS.LAB_INVENTORY_ALL_TOOLS.filter((tools) => {
      return tools.text === "IMS";
    });
  const TaiwanData: IComboBoxOption[] =
    APP_SETTINGS.LAB_INVENTORY_ALL_TOOLS.filter((tools) => {
      return tools.text === "Taiwan";
    });
  return (
    (IMSData.length > 0 && labInventoryItem.sourceToolId === IMSData[0].key) ||
    (TaiwanData.length > 0 &&
      labInventoryItem.sourceToolId === TaiwanData[0].key)
  );
};
export const getLeaseOwner = (
  labInventoryLeases: Array<IEcaasLease> | [] | null
) => {
  if (
    labInventoryLeases &&
    labInventoryLeases.length > 0 &&
    labInventoryLeases[0].itemStatus !== "Completed"
  ) {
    if (
      labInventoryLeases[0].userId !== 0 &&
      labInventoryLeases[0].user !== null
    ) {
      return labInventoryLeases[0].user.alias;
    } else if (labInventoryLeases[0].userId === 0) {
      return "Lab Inventory Admin";
    }
  }
  return "";
};

export const checkForElementExist = (
  types: Array<string>,
  value: string | null | undefined
) => {
  return types.some(
    (item) => value && item.toLowerCase() === value.toLowerCase()
  );
};

export const roundOfGivenValue = (value: number) => {
  return (Math.round((value / 1000) * 10) / 10).toFixed(1);
};

export const getExportDateStamp = (): string =>
  new Date().toLocaleDateString('en-US').replaceAll('/', '_');

export const getDocumentTitle = (pageTitle: string) => {
  return `${pageTitle + " | " + process.env.REACT_APP_NAME}`;
}


